import { LOAN_REQUEST_OFFER_COMMISSION_STATUSES } from 'cpool-constants';
import { z } from 'zod';

export const schemaEuropaceCommissionData = z.object({
    provisionInEuro: z.number(),
    provisionRelatedToAuszahlungsbetrag: z.number(),
    provisionRelatedToBasisbetrag: z.number(),
});

export type SchemaEuropaceCommissionData = z.infer<typeof schemaEuropaceCommissionData>;

export const schemaEuropaceCommission = z.object({
    data: schemaEuropaceCommissionData.optional(),
    status: z.nativeEnum(LOAN_REQUEST_OFFER_COMMISSION_STATUSES),
});

export type SchemaEuropaceCommission = z.infer<typeof schemaEuropaceCommission>;
